//custom colors defined in tailwind.config.js colors section, indexable in classNames via this enum
export enum Theme {
    orange = '3GT-orange', //#f5a220
    orangeHover = '3GT-orangeHover', //#c98418
    offWhite = '3GT-offWhite', //#F8F8F8
    darkBlue = '3GT-darkblue', //#1560AC
}
